import React, { useState, useEffect } from 'react';
import _trim from 'lodash/trim';
import _find from 'lodash/find';
import _isEmpty from 'lodash/isEmpty';
import _size from 'lodash/size';
import _replace from 'lodash/replace';
import _toUpper from 'lodash/toUpper';
import PCode from 'styles/blocks/address';

const removeNonPostcodeChars = postcode => {
  const postcodeWithAllowedChars = _replace(postcode, /[^\d\s\w]/g, '');
  return _trim(postcodeWithAllowedChars);
};

export const containsNonPostcodeChars = postcode => !postcode?.match(/^[a-zA-Z0-9\s-]+$/);

export function Postcode(props) {
  const {
    findAddresses,
    validPostcodes,
    postcode,
    questionText,
    updatePostcode,
    validatePostcode,
    isPostcodeOk,
    setIsPostcodeOk,
    validationErrors,
    isReadOnly,
    postcodeAnswerId,
  } = props;
  const [isPostCodeInvalid, setIsPostCodeInvalid] = useState(false);
  const trimmedPostcode = removeNonPostcodeChars(postcode);
  const isPostcodeInAPIValidationErrors = _find(validationErrors, error => error.reference === postcodeAnswerId);

  useEffect(() => {
    if (_isEmpty(validPostcodes)) {
      setIsPostcodeOk(false);
    } else if (!validPostcodes || _size(validPostcodes) >= 2) {
      setIsPostCodeInvalid(true);
      setIsPostcodeOk(false);
    } else if (_size(validPostcodes) === 1) {
      setIsPostCodeInvalid(false);
      setIsPostcodeOk(true);
    }
  }, [validPostcodes, setIsPostcodeOk]);

  useEffect(() => {
    if (_size(validPostcodes) === 1 && _replace(validPostcodes[0], ' ', '') !== _replace(_toUpper(trimmedPostcode), ' ', '')) {
      setIsPostcodeOk(false);
    }
  }, [trimmedPostcode, validPostcodes, setIsPostcodeOk]);

  const handleValidatePostcode = () => {
    if (containsNonPostcodeChars(postcode)) {
      setIsPostcodeOk(false);
      return setIsPostCodeInvalid(true);
    }
    if (_size(trimmedPostcode) === 0) {
      return setIsPostcodeOk(false);
    }
    if (_size(trimmedPostcode) <= 3) {
      setIsPostcodeOk(false);
      return setIsPostCodeInvalid(true);
    }
    return validatePostcode(trimmedPostcode).then(response => (!response ? setIsPostCodeInvalid(true) : response));
  };

  const handleClickFindAddress = () => {
    if (isPostcodeOk) {
      return findAddresses(trimmedPostcode);
    }
    if (trimmedPostcode <= 3) {
      return setIsPostCodeInvalid(true);
    }
    return validatePostcode(trimmedPostcode)
      .then(response => (response && _size(response) === 1 ? findAddresses(trimmedPostcode) : setIsPostCodeInvalid(true)));
  };

  return (
    <PCode>
      <PCode.Text>{questionText}</PCode.Text>
      {isPostcodeInAPIValidationErrors && <PCode.Error>Postcode cannot be left blank</PCode.Error>}
      {isPostCodeInvalid && <PCode.Error>Please enter a valid postcode</PCode.Error>}
      <PCode.InputContainer>
        <PCode.Input
          value={postcode}
          isInvalid={isPostCodeInvalid || isPostcodeInAPIValidationErrors}
          onChange={event => updatePostcode(_toUpper(event.target.value))}
          onBlur={() => handleValidatePostcode()}
          aria-label="Your postcode"
          maxLength="8"
          readOnly={isReadOnly}
          id="postCode-input"
          data-automation="postCode-input"
        />
        {isPostcodeOk && <PCode.OkIcon />}
      </PCode.InputContainer>
      <PCode.InputContainer>
        <PCode.FindAddressButton
          onClick={() => handleClickFindAddress()}
          type="button"
        >
          Find address
        </PCode.FindAddressButton>
      </PCode.InputContainer>
    </PCode>
  );
}
